module.exports = __webpack_public_path__ + "static/media/metaverse.00b22331.png";